module.exports = __webpack_public_path__ + "img/Loading_46@3x.472b1a40.png";